import { lazy, Suspense } from "react";

const TourManagerContent = lazy(() => import("./TourManagerContent"));

/**
 * Joyride + Popper are heavy; keep them out of the main bundle via dynamic import.
 * MountWhenVisible is applied in __root with a top-of-layout sentinel so it intersects
 * on first paint (tours that target above-the-fold UI still work). Do not place the
 * sentinel only below long page content or tours may load too late.
 */
export default function TourManager() {
  return (
    <Suspense fallback={null}>
      <TourManagerContent />
    </Suspense>
  );
}
